/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import React, { ComponentProps, ReactNode, memo } from 'react';
import IconChevronDownSmall from '../icon/chevron-down-small';
import styles from './accordion-item.module.sass';

export const AccordionItemButton = memo(
  ({
    className,
    children,
    icon,
    chevron = <IconChevronDownSmall />,
    ...props
  }: ComponentProps<'button'> & {
    chevron?: ReactNode;
    icon?: ReactNode;
  }) => (
    <button type="button" className={classNames(styles.accordionItemButton, className)} {...props}>
      {icon && <span className={styles.accordionItemIcon}>{icon}</span>}
      <span className={styles.accordionItemLabel}>
        {children}
        {chevron && <span className={styles.accordionItemChevron}>{chevron}</span>}
      </span>
    </button>
  ),
);
